import { render } from "./oficialiaMenu.vue?vue&type=template&id=00cb06a2&scoped=true"
import script from "./oficialiaMenu.vue?vue&type=script&lang=js"
export * from "./oficialiaMenu.vue?vue&type=script&lang=js"

import "./oficialiaMenu.vue?vue&type=style&index=0&id=00cb06a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cb06a2"]])

export default __exports__